export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'Campo obrigatório',
  INVALID_CPF: 'CPF incorreto',
  INVALID_NAME: 'Informe um nome correto',
  INVALID_EMAIL: 'Informe um e-mail correto',
  INVALID_DATE: 'Informe uma data correta',
  LEGAL_AGE: 'É necessário ter pelo menos 18 anos',
  INVALID_CELLPHONE: 'Informe um número de telefone celular com 11 dígitos',
  REQUIRED_ACCEPT_TERM: 'É necessário aceitar o termo',
}
